'use client';

import { Loader2 } from 'lucide-react';
import { useSelector } from 'react-redux';
import { EventInfoHeader } from '../../../components';
import {
  DateTimeSelection,
  TicketSelection
} from './components';
import { useEventInfo } from './hooks';

const steps: any = {
  0: DateTimeSelection,
  1: TicketSelection,
}

const BuyTicketSection = ({ eventId }: any) => {
  const { eventInfo, loading, step, onNext } = useEventInfo(eventId);
  
  const Step = steps[step];

  const cartData = useSelector(
    (state: any) => state?.user?.cart,
  );

  return (
    <div className='flex flex-col items-center bg-gray-100'>
      <EventInfoHeader
        eventDate={cartData?.selectedDate?.date}
        eventLocation={eventInfo ? eventInfo.eventAddress : null}
        eventName={eventInfo ? eventInfo.name : null}
        loading={loading}
      />

      <div className='flex w-full h-full flex-col items-center justify-start gap-4'>
        {loading ? (
          <div className='flex w-full items-center justify-center py-10'>
            <Loader2 className='h-8 w-8 animate-spin text-gray-500' />
          </div>
        ) : (
          <Step onNext={onNext} eventInfo={eventInfo} />
        )}
      </div>
    </div>
  );
};

export default BuyTicketSection;
